import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "TipoCapacitacionPage",
    data() {
        let ss = new MainService();
        return {
            msg: "TipoCapacitacionPage",
            ss: ss,
            auth: {},

            ajax: {
                "url": ss.indexTipoCapacitacion(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'TipoCapacitacion', name: 'TipoCapacitacion', title: 'TipoCapacitacion' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripcion' },
                //{ data: 'Rol', name: 'Rol', title: 'Rol' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            isLoading: false,
            isLoadingFile: false,
            errorBag: {},
            tipoCapacitacion: {},

        };
    },
    methods: {
    
        newTipoCapacitacion() {
            this.tipoCapacitacion = {};
            this.$refs['frm-tipoCapacitacion'].show();
            // console.log("hhhhola")
        },
        showTipoCapacitacion(id) {
            this.isLoading = true;
            this.ss.showTipoCapacitacion(id).then(
                (result) => {
                    let response = result.data;
                    this.tipoCapacitacion = response.data;
                    this.$refs['view-tipoCapacitacion'].show();
                    this.isLoading = false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading = false;
            });
        },
        editTipoCapacitacion() {
            this.$refs['frm-tipoCapacitacion'].show();
            this.$refs['view-tipoCapacitacion'].hide();
        },
        cancelTipoCapacitacion() {
            if (this.tipoCapacitacion.id) {
                this.$refs['view-tipoCapacitacion'].show();
            }
            this.$refs['frm-tipoCapacitacion'].hide();
        },
        saveTipoCapacitacion() {
            this.ss.storeTipoCapacitacion(this.tipoCapacitacion).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-tipoCapacitacion'].hide();
                    this.$refs['datatable-tipoCapacitacion'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    console.log(error.response.data);
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteTipoCapacitacion() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyTipoCapacitacion(this.tipoCapacitacion)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-tipoCapacitacion'].hide();
                                this.$refs['datatable-tipoCapacitacion'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },

        draw() {
            window.$('.btn-datatable-TipoCapacitacion').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showTipoCapacitacion(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {

        var persona = JSON.parse(localStorage.getItem('persona'));
        this.auth = JSON.parse(localStorage.getItem("persona"));
        if (!persona) {
            this.$router.push('/Login');
        } else {
            this.getPersona();
            this.getTipoTipoCapacitacion()
        }
    }
};
